import React from 'react';
import clsx from 'clsx';

type PillTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'gold' | 'silver' | 'platinum';

interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone;
  outline?: boolean;
}

export const Pill: React.FC<PillProps> = ({ tone = 'neutral', outline, className, children, ...rest }) => (
  <span className={clsx('ui-pill', `ui-pill--${tone}`, outline && 'ui-pill--outline', className)} {...rest}>
    {children}
  </span>
);
